import React from 'react'
import { HitlabelContext } from '@hitlabel.jp/main-site/context'
import type { HitlabelContextType } from '@hitlabel.jp/main-site/types'

export const useHitlabelContext = () => {
  const context = React.useContext(HitlabelContext) as HitlabelContextType
  return context
}
